import { Divider, ListItemText, MenuItem } from '@mui/material';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { useDeleteMeasurement } from '../../../../../hooks/requests/use-delete-measurement';
import { useDialog } from '../../../../../hooks/use-dialog';
import { runMutation } from '../../../../../utils/vy-mutation';

type DeleteMeasurementDialogProps = {
  measurementId: string;
};

export const DeleteMeasurementDialog: React.FC<DeleteMeasurementDialogProps> = ({ measurementId }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();
  const deleteMeasurementMutation = useDeleteMeasurement();

  const handleDialogSubmit = async () => {
    handleClose();
    await runMutation(deleteMeasurementMutation, measurementId, {
      pending: 'Deleting...',
      success: 'Deleted',
      error: 'Failed to delete measurement',
    });
  };

  return (
    <>
      <Divider className="mt-0" />

      <MenuItem onClick={handleOpen}>
        <ListItemText sx={{ color: '#D32F2F' }}>Delete</ListItemText>
      </MenuItem>

      <VyDialog
        open={isDialogOpen}
        onClose={handleClose}
        label="Delete measurement"
        labelDescription="Are you sure you want to delete this measurement?"
        warningText="This action is final and cannot be reversed"
        cancelButtonText="Cancel"
        ctaText="Delete"
        ctaDisabled={deleteMeasurementMutation.isLoading}
        onSubmit={handleDialogSubmit}
      />
    </>
  );
};
